export default __webpack_public_path__ + "static/media/donot_want.21a33627.svg";